import moment from "moment";
import { amountFormat } from "../services/common.service";
import { Empty, Table } from "antd";
import { useTranslation } from "react-i18next";
import { MdOutlineEdit } from "react-icons/md";
import { useEffect, useState } from "react";
import PaginationComponent from "./paginationComponet";
import { useSelector } from "react-redux";
import { selectedAccountSelector } from "../store/selectors/app.selector";

export default function AccountMiniStatementGrid({
  dataSource,
  accountDetails,
  setVisible,
  setSelectedDetails,
  remarksIcons,
  noRecords,
}) {
  const { t } = useTranslation();
  const selectedAccount = useSelector(selectedAccountSelector);
  return (
    <Table
        dataSource={dataSource}
        rowClassName={(record, index) =>
          index % 2 === 0 ? "table-row-light" : "table-row-dark"
        }
        tableLayout="fixed"
        pagination={false}
        bordered
        sticky={true}
        columns={[
          {
            title: "Trans Date",
            key: "txnDate",
            width: 150,
            render: (option) => (
              <>
                <span style={{ fontSize: "13px" }}>
                  {moment(option.txnDate).format("DD-MM-YYYY")}
                </span>
              </>
            ),
          },
          {
            title: "Value Date",
            key: "txnValuedDate",
            width: 150,
            render: (option) => (
              <>
                <span style={{ fontSize: "13px" }}>
                  {moment(option.txnValuedDate).format("DD-MM-YYYY")}
                </span>
              </>
            ),
          },
          {
            title: "Reference Number",
            key: "refNo",
            width: 200,
            render: (option) => (
              <>
                <span style={{ fontSize: "13px" }}>{option?.refNo}</span>
              </>
            ),
          },
          {
            title: "Description",
            key: "narration",

            render: (option) => (
              <>
                <span style={{ fontSize: "13px" }}>
                  {option?.narration || option?.txnTypeDesc}
                </span>
              </>
            ),
          },
          {
            title: `Debit (${selectedAccount?.accountCurrency})`, // "Debit (ZMW)"
            key: "debit",
            align: "right",
            width: 130,
            render: (option) => (
              <span
                style={{ fontSize: "13px" }}
                className={
                  option?.debitOrCredit === "Debit" ? "debit" : "credit"
                }
              >
                {option.debitOrCredit === "Debit" &&
                  amountFormat(option.amount || "", "")}
              </span>
            ),
          },

          {
            title: `Credit (${selectedAccount?.accountCurrency})`,  // "Credit (ZMW)",
            key: "credit",
            align: "right",
            width: 130,
            render: (option) => (
              <span
                style={{ fontSize: "13px" }}
                className={
                  option?.debitOrCredit === "Credit" ? "credit" : "debit"
                }
              >
                {option.debitOrCredit === "Credit" &&
                  amountFormat(option.amount || "", "")}
              </span>
            ),
          }
        ]}
      />
  );
}
